/**
 * Load the response from an AJAX request in to a DOM element specified via the
 * data-target attribute.
 */
$(document).on("click change", ".js-load", function(e) {
  e.preventDefault();

  let $this = $(this);
  let url = $this.attr('href');
  let $target = $($this.data('target'));
  $target.load(url);
});
